import { createNextTableContext } from '@core/table';

export const UsersTableContext = createNextTableContext();
